import {observer} from 'mobx-react';
import {withState} from 'shared/core';
import {Layout, Panel} from 'shared/components';
import ExpensesSubnav from '../../ExpensesSubnav';
import PolicyDirectory from './PolicyDirectory';
import {ManageContainerState} from '../state';

const ManageContainer = observer(({scope, uiState}) => {
  return (
    <div>
      <ExpensesSubnav scope={scope}/>
      <Layout>
        <Panel.Stack loose>
          <PolicyDirectory uiState={uiState}/>
        </Panel.Stack>
      </Layout>
    </div>
  );
});

export default withState(ManageContainer, ManageContainerState);
